import { FetchAPI, User } from './auth-service';

const fields = [
    {
        variable: 'name',
        title: 'Name',
        field: 'name',
        type: 'string',
        headerName: 'Name',
        width: 200
    },
    {
        variable: 'ID',
        title: 'ID',
        field: 'ID',
        type: 'string',
        headerName: 'Access Key',
        width: 320,
    },
    {
        variable: 'UserID',
        title: 'Username',
        field: 'UserID',
        type: 'string',
        headerName: 'Username',
        width: 150
    },
    {
        variable: 'active',
        title: 'Active',
        field: 'active',
        type: 'boolean',
        headerName: 'Active',
        width: 150
    },
    {
        variable: 'created',
        title: 'Created',
        field: 'created',
        type: 'date',
        headerName: 'Created',
        width: 150,
    },
    {
        variable: 'last_used',
        title: 'Last Used',
        field: 'last_used',
        type: 'date',
        headerName: 'Last Used',
        width: 150,
    },
    {
        variable: 'expiration',
        title: 'Expiration',
        field: 'expiration',
        type: 'date',
        headerName: 'Expiration',
        width: 150,
    },
];

class AccesskeysDataService {
    constructor () {
        if (!AccesskeysDataService.instance) {
            AccesskeysDataService.instance = this;
        }

        this.listAccessKeys = () => {
            return FetchAPI({ method: 'GET', url: 'auth/keys' });
        };

        this.createAccessKey = ({
            name,
            Domain,
            expiration,
        }) => {
            return FetchAPI({
                method: 'POST',
                url: 'auth/keys',
                body: {
                    name,
                    Domain,
                    expiration,
                }
            });
        };

        this.deactivateAccessKey = uuid => {
            return FetchAPI({
                method: 'PUT',
                url: `auth/keys/${uuid}/-deactivate`
            });
        };

        this.activateAccessKey = uuid => {
            return FetchAPI({
                method: 'PUT',
                url: `auth/keys/${uuid}/-activate`
            });
        };

        this.deleteAccessKey = uuid => {
            return FetchAPI({
                method: 'DELETE',
                url: `auth/keys/${uuid}`
            });
        };

        this.rotateAccessKey = uuid => {
            return FetchAPI({
                method: 'PUT',
                url: `auth/keys/${uuid}/-rotate`
            });
        };

        return AccesskeysDataService.instance;
    }
}

const AccessKeysService = new AccesskeysDataService();

export {
    AccessKeysService as default,
    fields
};
